type Options = MutationObserverInit & { callback: MutationCallback }
export function useMutationObserver(node: HTMLElement, options: Options) {
  const { callback, ...mutationOptions } = options
  let observer = new MutationObserver(callback)
  observer.observe(node, mutationOptions)

  return {
    update(options: Options) {
      observer.disconnect()
      const { callback, ...mutationOptions } = options
      observer = new MutationObserver(callback)
      observer.observe(node, mutationOptions)
    },
    destroy() {
      observer.disconnect()
    },
  }
}
